import {mergeWith} from "lodash";


const mutations = {
  setList: (state, list) => {
    state.list = list;
  },
  setPageInfo: (state, pageInfo) => {
    state.pageInfo = pageInfo;
  },
  setCondition: (state, condition) => {
    state.condition = condition;
  },
};
export default mutations;
